import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, MessageCircle, Mail, Clock } from "lucide-react";
import logoSinconta from "@/assets/logo-sinconta.png";
const footerLinks = {
  servicios: [{
    name: "RESICO",
    href: "/resico"
  }, {
    name: "Actividad Empresarial",
    href: "/actividad-empresarial"
  }, {
    name: "Asistente IA",
    href: "/asistente-ia"
  }, {
    name: "Facturación CFDI",
    href: "/facturacion"
  }, {
    name: "Declaraciones",
    href: "/declaraciones"
  }],
  recursos: [{
    name: "Blog",
    href: "/blog"
  }, {
    name: "Herramientas",
    href: "/herramientas"
  }, {
    name: "Glosario Fiscal",
    href: "/glosario"
  }, {
    name: "Preguntas Frecuentes",
    href: "/faq"
  }, {
    name: "Guías SAT",
    href: "/guias-sat"
  }],
  empresa: [{
    name: "Nosotros",
    href: "/nosotros"
  }, {
    name: "Precios",
    href: "/precios"
  }, {
    name: "Programa de Referidos",
    href: "/referidos"
  }, {
    name: "Contacto",
    href: "/contacto"
  }, {
    name: "Aviso de Privacidad",
    href: "/privacidad"
  }, {
    name: "Términos y Condiciones",
    href: "/terminos"
  }]
};
const socialLinks = [{
  name: "Facebook",
  icon: Facebook,
  href: "https://facebook.com/sinconta"
}, {
  name: "Instagram",
  icon: Instagram,
  href: "https://instagram.com/sinconta"
}, {
  name: "LinkedIn",
  icon: Linkedin,
  href: "https://linkedin.com/company/sinconta"
}, {
  name: "WhatsApp",
  icon: MessageCircle,
  href: "https://wa.me/5215586879082"
}];
export function Footer() {
  return <footer className="bg-primary text-primary-foreground">
      <div className="container-custom py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <img src={logoSinconta} alt="SinConta Logo" className="h-10 w-auto brightness-0 invert" />
            </Link>
            <p className="text-primary-foreground/70 mb-6 max-w-sm">
              El servicio de contabilidad más accesible de México. Potenciado por inteligencia artificial para personas físicas.
            </p>
            <div className="space-y-3 text-sm">
              <a className="flex items-center gap-2 text-primary-foreground/70 hover:text-secondary transition-colors" href="https://wa.me/525586879082">
                <MessageCircle className="w-4 h-4" />
                +52 5586879082  
              </a>
              <a className="flex items-center gap-2 text-primary-foreground/70 hover:text-secondary transition-colors" href="mailto:a.ceron@sinconta.com">
                <Mail className="w-4 h-4" />
                a.ceron@sinconta.com
              </a>
              <div className="flex items-center gap-2 text-primary-foreground/70">
                <Clock className="w-4 h-4" />
                Lun-Vie 9:00 - 18:00 hrs
              </div>
            </div>
          </div>

          {/* Links Columns */}
          <div>
            <h3 className="font-heading font-semibold mb-4 text-secondary text-base">Servicios</h3>
            <ul className="space-y-3">
              {footerLinks.servicios.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-primary-foreground/70 hover:text-secondary transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold mb-4 text-secondary text-base">Recursos</h3>
            <ul className="space-y-3">
              {footerLinks.recursos.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-primary-foreground/70 hover:text-secondary transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold mb-4 text-secondary text-base">Empresa</h3>
            <ul className="space-y-3">
              {footerLinks.empresa.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-primary-foreground/70 hover:text-secondary transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-primary-foreground/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-sm text-primary-foreground/60">
              <span>© 2025–2026 SinConta. Todos los derechos reservados.</span>
              <span className="hidden md:inline">•</span>
              <span className="hidden md:inline">100% mexicanos 🇲🇽</span>
            </div>
            <div className="flex items-center gap-4">
              {socialLinks.map(social => <a key={social.name} href={social.href} target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg bg-primary-foreground/5 hover:bg-secondary hover:text-secondary-foreground transition-all" aria-label={social.name}>
                  <social.icon className="w-5 h-5" />
                </a>)}
            </div>
          </div>
        </div>
      </div>
    </footer>;
}